import React from "react";
import { Box, Typography, Paper } from "@mui/material";
import { EmojiEvents as TrophyIcon } from "@mui/icons-material";

const medalFor = (rank, isCorrect) => {
  if (!isCorrect) return null;
  if (rank === 1) return "🥇";
  if (rank === 2) return "🥈";
  if (rank === 3) return "🥉";
  return null;
};

const FFFLeaderboardView = ({ entries = [], deviceId, spectatorMode }) => {
  const myIndex = entries.findIndex((e) => String(e.device_id || "") === String(deviceId || ""));
  const myEntry = myIndex >= 0 ? entries[myIndex] : null;

  return (
    <Box
      sx={{
        minHeight: "100vh",
        bgcolor: "#050a14",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        p: { xs: 2, sm: 3 },
      }}
    >
      <Typography
        variant="h5"
        sx={{
          color: "#29b6f6",
          fontWeight: 800,
          letterSpacing: 1,
          textAlign: "center",
        }}
      >
        Fastest Finger First
      </Typography>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 0.5, mb: 2 }}>
        <TrophyIcon sx={{ color: "#ffd700" }} />
        <Typography
          variant="h4"
          sx={{
            color: "#ffd700",
            fontWeight: 800,
            textAlign: "center",
            textShadow: "0 0 24px rgba(255,215,0,0.35)",
          }}
        >
          Leaderboard
        </Typography>
      </Box>

      {!spectatorMode && myEntry && (
        <Typography sx={{ color: "#4fc3f7", mb: 1.5, fontWeight: 600 }}>
          You placed #{myEntry.rank}
          {myEntry.is_correct ? "" : " — incorrect"}
          {myEntry.time_taken_seconds != null ? ` · ${myEntry.time_taken_seconds}s` : ""}
        </Typography>
      )}

      <Paper
        sx={{
          width: "100%",
          maxWidth: 640,
          bgcolor: "#0d2137",
          border: "2px solid #29b6f6",
          borderRadius: 3,
          p: { xs: 1.5, sm: 2 },
          boxShadow: "0 0 20px rgba(41,182,246,0.2)",
          maxHeight: "62vh",
          overflow: "auto",
        }}
      >
        {entries.length === 0 ? (
          <Typography sx={{ color: "#888", textAlign: "center", py: 4 }}>
            No answers this round
          </Typography>
        ) : (
          entries.map((entry) => {
            const isMe = String(entry.device_id || "") === String(deviceId || "");
            const medal = medalFor(entry.rank, entry.is_correct);
            return (
              <Box
                key={`${entry.device_id}-${entry.rank}`}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1.25,
                  mb: 0.75,
                  px: 1.25,
                  py: 1,
                  borderRadius: 2,
                  bgcolor: isMe
                    ? "rgba(255,215,0,0.16)"
                    : entry.rank === 1 && entry.is_correct
                      ? "rgba(255,215,0,0.08)"
                      : "rgba(0,0,0,0.25)",
                  border: isMe
                    ? "1px solid #ffd700"
                    : "1px solid transparent",
                }}
              >
                <Typography
                  sx={{
                    minWidth: 36,
                    fontWeight: 800,
                    color:
                      entry.rank === 1 && entry.is_correct
                        ? "#ffd700"
                        : entry.is_correct
                          ? "#fff"
                          : "#888",
                  }}
                >
                  {medal || `#${entry.rank}`}
                </Typography>
                <Typography
                  sx={{
                    flex: 1,
                    fontWeight: isMe ? 800 : 600,
                    color: entry.is_correct ? "#fff" : "#aaa",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                >
                  {entry.display_name}
                  {isMe && !spectatorMode ? " (You)" : ""}
                </Typography>
                <Typography
                  sx={{
                    fontWeight: 700,
                    fontSize: "0.85rem",
                    color: entry.is_correct ? "#4caf50" : "#ef5350",
                    minWidth: 72,
                    textAlign: "right",
                  }}
                >
                  {entry.is_correct ? "Correct" : "Wrong"}
                </Typography>
                <Typography
                  sx={{
                    minWidth: 52,
                    textAlign: "right",
                    color: "#29b6f6",
                    fontWeight: 700,
                  }}
                >
                  {entry.time_taken_seconds != null ? `${entry.time_taken_seconds}s` : "—"}
                </Typography>
              </Box>
            );
          })
        )}
      </Paper>

      <Typography sx={{ color: "#4fc3f7", mt: 2.5, textAlign: "center", fontSize: "1rem" }}>
        Waiting for the host to choose the Hot Seat...
      </Typography>
    </Box>
  );
};

export default FFFLeaderboardView;
